import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-4" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1)
const _hoisted_5 = { class: "row g-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_7 = { class: "d-flex flex-column gap-5 h-100" }
const _hoisted_8 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfigGrupo = _resolveComponent("ConfigGrupo")!
  const _component_ConfigPreferGrupo = _resolveComponent("ConfigPreferGrupo")!
  const _component_ConfigApp = _resolveComponent("ConfigApp")!
  const _component_ConfigMarcasParceiras = _resolveComponent("ConfigMarcasParceiras")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Configurando grupo " + _toDisplayString(_ctx.dadosGrupo.nome || ''), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          type: "button",
          text: "Voltar",
          onClick: _ctx.redirectToGroups
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          type: "button",
          variant: "secondary",
          text: "Salvar",
          onClick: _ctx.salvaGrupo
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ConfigGrupo, {
            class: "h-100",
            dadosGrupo: _ctx.dadosGrupo,
            onReceiveAttComponents: _cache[0] || (_cache[0] = ($event: any) => (_ctx.receiveAttComponents($event)))
          }, null, 8, ["dadosGrupo"]),
          _createVNode(_component_ConfigPreferGrupo, {
            class: "h-100",
            preferGrupo: _ctx.preferGrupo,
            onReceiveAttComponents: _cache[1] || (_cache[1] = ($event: any) => (_ctx.receiveAttComponents($event)))
          }, null, 8, ["preferGrupo"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_ConfigApp, {
          grupoSelecionado: _ctx.grupo,
          onReceiveAttComponents: _cache[2] || (_cache[2] = ($event: any) => (_ctx.receiveAttComponents($event)))
        }, null, 8, ["grupoSelecionado"])
      ])
    ]),
    _createVNode(_component_ConfigMarcasParceiras, {
      marcasParceirasApi: _ctx.marcasParceirasApi,
      onReceiveAttParceiros: _cache[3] || (_cache[3] = ($event: any) => (_ctx.receiveAttParceiros($event)))
    }, null, 8, ["marcasParceirasApi"])
  ]))
}